// This is different than the show_assign_devices_dialog controller, which uses 
// dialogs/assign_devices.
// That one requires a devicegroup, this one doesn't.
import _ from 'underscore';
import Radio from 'backbone.radio';
import MoveDevicesDialog from '@/views/dialogs/move_devices';

    var globalCh = Radio.channel('global');
    var apiCh = Radio.channel('api');

    function show_move_devices(options) {
        var active = globalCh.request('active_account');
        var primary = globalCh.request('primary_account');

        var groups = apiCh.request('development_devicegroup');
        options = _.extend({
            // Send an array of device IDs to populate the textarea
            device_ids: null,
            // Preselect a devicegroup (product will be selected
            // automatically)
            selected_devicegroup: null,
            // Preselect a product
            selected_product: null,
            omitted_types: []
        }, options);

        if (!active.permits(primary, 'update_development_devicegroup')) {
            options.omitted_types.push('development_devicegroup');
        }

        if (!active.permits(primary, 'update_pre_production_devicegroup')) {
            options.omitted_types.push('pre_production_devicegroup');
        }

        if (!active.permits(primary, 'update_pre_factory_devicegroup')) {
            options.omitted_types.push('pre_factoryfixture_devicegroup');
        }

        if (!active.permits(primary, 'update_factory_devicegroup')) {
            options.omitted_types.push('factoryfixture_devicegroup');
        }

        if (!active.permits(primary, 'update_production_devicegroup')) {
            options.omitted_types.push('production_devicegroup');
        }

        options.omitted_types = _.uniq(options.omitted_types);

        groups.fetch({
            remove: false,
            success: function() {
                var view = new MoveDevicesDialog(options);
                globalCh.request('showDialog', view);
            }
        });
    }
    export default show_move_devices;

